import { Button } from '@mantine/core'
import { useRouter } from 'next/router'

import { api, notificationHandler } from '@/lib/utils'
import { useAuth } from '@/providers/AuthProvider'

interface Props {
  productSlug: string
  [key: string]: any
}

export default function ProductAlert({ productSlug, ...restProps }: Props) {
  // Hooks
  const { isAuthenticated } = useAuth() || {}
  const router = useRouter()

  // Constants
  const {
    site: siteSlug,
    channel: channelSlug,
    store: storeSlug,
    showcase: showcaseSlug
  } = router.query || {}

  // Actions
  const handleAlert = async (productSlug: string) => {
    if (!isAuthenticated) {
      router.push(`/accounts/login?callbackUrl=${router.asPath}`)
    } else {
      try {
        const response = await api.post(
          `/${siteSlug}/channels/${channelSlug}/stores/${storeSlug}/showcases/${showcaseSlug}/products/${productSlug}/alert/`
        )
        const { data, status } = response || {}
        if (status === 201 && data?.detail) {
          notificationHandler({ variant: 'success', message: response.data.detail })
        }
      } catch (error: any) {
        notificationHandler({
          variant: 'error',
          message: error?.response?.data?.detail || 'Erro ao criar alerta'
        })
      }
    }
  }

  return (
    <Button
      variant="outline"
      fullWidth
      onClick={() => handleAlert(productSlug)}
      color="orange"
      {...restProps}>
      Avise-me
    </Button>
  )
}
